<template>
    <div class="page-module-wrap">
        <div class="section-gap">
            <div class="block clearfix">
                <div class="control fleft search-component">
                    <label style="font-weight: bold;color: #000">投票标题</label>
                    <input style="width: 300px" type="text" v-model="search.title">
                    <button class='button is-primary' @click="searchVote">搜索</button>
                    <button class="button is-info" style="margin-left: 20px;" @click="clear">清空</button>
                </div>
            </div>
        </div>

        <div class="list-wrap">
            <div class="like-button">
                <p class="buttonStyle">
                    <button class="button is-success margin-top" @click="goEdit(0)">添加投票</button>
                </p>
            </div>
            <div v-if="count > 0" class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
            <div class="">
                <article  v-for="(item,index) in list" class="vote-card block">
                    <div class="vote-title">
                        <div><span  class="font-weight">投票标题</span><span class="title-con">{{item.title}}</span></div>
                    </div>
                    <div class="vote-tab">
                        <div  class="font-weight">
                            <span>票数</span>
                            <span class="color" :class="{'vote-active':item.isShowFake===1}" @click="changeShowFake(1,index)">全部</span>
                            <span class="color" :class="{'vote-active':item.isShowFake===0}" @click="changeShowFake(0,index)">真实</span>
                        </div>
                    </div>
                    <div class="block vote-content">
                        <div class="fleft vote-options">
                            <p style="font-weight: bold">选项</p>
                            <div  class="vote-item" v-for="(optionItem,optionIndex) in item.options">
                                <div v-if="item.isShowFake">
                                    <p style="padding-bottom: 10px;width:470px">{{optionItem.optionName}}</p>
                                    <div class="fleft">
                                        <div class="vote-progress">
                                            <div class="true fleft" :style="{'width':(optionItem.voteCount/(item.voteTotalCount+item.fakeTotalCount)*100)+'%'}"></div>
                                            <div class="fake fleft" :style="{'width':(optionItem.fakeCount/(item.voteTotalCount+item.fakeTotalCount)*100)+'%'}"></div>
                                        </div>
                                    </div>
                                    <div class="fleft ticket">{{optionItem.voteCount+optionItem.fakeCount}}票</div>
                                    <div class="fleft ticket" v-if="(item.voteTotalCount+item.fakeTotalCount)!=0">
                                        {{((optionItem.voteCount+optionItem.fakeCount)/(item.voteTotalCount+item.fakeTotalCount)*100).toFixed(2)}}%
                                    </div>
                                    <div class="fleft ticket" v-else>0.00%</div>
                                </div>
                                <div v-else>
                                    <p style="padding-bottom: 10px">{{optionItem.optionName}}</p>
                                    <div class="fleft">
                                        <div class="vote-progress">
                                            <div class="true fleft" :style="{'width':(optionItem.voteCount/item.voteTotalCount*100)+'%'}"></div>
                                        </div>
                                    </div>
                                    <div class="fleft ticket">{{optionItem.voteCount}}票</div>
                                    <div class="fleft ticket" v-if="item.voteTotalCount!=0">{{(optionItem.voteCount/item.voteTotalCount*100).toFixed(2)}}%</div>
                                    <div class="fleft ticket" v-else>0.00%</div>
                                </div>
                            </div>
                        </div>
                        <div class="fleft vote-type">
                            <p><span  class="font-weight">投票类型：</span>
                                <span v-if="item.type==0">单选</span>
                                <span v-if="item.type==1">多选</span>
                            </p>
                            <p v-if="item.type==1&&item.selectCount">
                                <span class="font-weight">最多选择：</span>{{item.selectCount}}个
                            </p>
                        </div>
                    </div>
                    <div>
                        <button class="button is-info" @click="goEdit(1,item,index)">编辑</button>
                        <button class='button is-danger' @click="deleteVote(item,index)">删除</button>
                    </div>
                </article>
            </div>
            <div v-if="count > 0" class="clearfix">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="search.page"
                        :page-size="search.pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="count"
                        class="fright">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="投票编辑" :visible.sync="visible" :lock-scroll="false" width="80%">
            <div class="vote-title margin-left">
                <div><span class="font-weight">投票标题</span><input style="width: 500px" type="text" v-model="modal.title">（建议50字以内）</div>
            </div>

            <div class="block vote-content margin-left">
                <div class="fleft vote-options">
                    <p class="font-weight">选项</p>
                    <div  class="vote-item" v-for="(optionItem,optionIndex) in modal.options">
                        <div class="fleft">
                            <span class="font-weight">选项{{optionIndex+1}}</span><input style="width: 300px" type="text" v-model="optionItem.optionName">
                        </div>
                        <div class="fleft " style="margin-left: 20px"><button class="button is-danger" @click="deleteOptions(optionIndex)">删除</button></div>
                        <div class="fleft" style="margin-left: 20px">加<input style="width: 50px" type="number" v-model.number="optionItem.fakeCount">票</div>
                    </div>
                    <div>
                        <button class="button is-info font-weight" @click="addOptions">添加选项</button>
                    </div>
                </div>
                <div class="fleft vote-type">
                    <p><span class="font-weight">投票类型：</span>
                        <el-radio v-model="modal.type" :label="0" @change="changeRadio">单选</el-radio>
                        <el-radio v-model="modal.type" :label="1" @change="changeRadio">多选</el-radio>
                    </p>
                    <p v-if="modal.type">
                        <span class="font-weight">最多选择：<input style="width: 50px" type="number" v-model.number="modal.selectCount">个</span>
                    </p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="doSave">确 定</el-button>
             </span>
        </el-dialog>
    </div>
</template>
<script type="text/babel">
    export default {
        data(){
            return {
                list:[],
                count:0,
                search:{
                    title:'',
                    page:1,
                    pageSize:20
                },
                modal: {},
                visible: false,
                bloggers: [],
                selectedBlogger: ""
            }
        },
        mounted(){
            this.getList(this.search);

        },
        methods:{
            changeRadio(value){
                if(value===0){
                    this.modal.selectCount=1
                }
                if(value===1){
                    this.modal.selectCount=null
                }
            },
            changeShowFake(num,index){
                if(this.list[index].isShowFake!==num){
                    this.list[index].isShowFake=num;
                }
            },
            addOptions(){
                this.modal.options.push({
                    'optionId':0,
                    'optionName':"",
                    'fakeCount':0,
                    'voteCount':0,
                })
            },
            deleteVote(item,index){
                if(confirm("确认要删除投票？")){
                    HttpRequest.get('/admin.php?method=fashion.deleteVote', {voteId:item.voteId}).then(response => {
                        if (response.data.success) {
                            this.$message("删除成功")
                            this.list.splice(index,1)
                        }
                    })
                }
            },
            deleteOptions(index){
                if(confirm("确认要删除该选项吗?")){
                    this.modal.options.splice(index,1)
                }
            },
            doSave() {
                let params = Object.assign({},this.modal)
                if(params.options.length<2){
                    this.$message("请至少填写两项");
                    return;
                }
                if(!params.title){
                    this.$message("请填写标题")
                    return;
                }
                for (var index in params.options){
                    if(!params.options[index].optionName){
                        this.$message("选项名称不能为空")
                        return;
                    }
                }
                params = JSON.parse(JSON.stringify(params));
                this.visible = false;
                HttpRequest.post('/admin.php?method=fashion.DoSaveVote', params).then(response => {
                    if (response.data.success === 1) {
                        this.$message("保存成功")
                        if(params.voteId==0){
                            this.getList(this.search);
                        }else{
                            HttpRequest.get('/admin.php?method=fashion.getVote', {voteId:response.data.voteId}).then(response => {
                                if (response.data) {
                                    let num=null;
                                    this.list[this.tempIndex].options.forEach((item,index)=>{
                                        num+=item.voteCount;
                                    });
                                    this.list[this.tempIndex].voteTotalCount=num;
                                    this.list[this.tempIndex].options=response.data.options;
                                    this.list[this.tempIndex].selectCount=response.data.selectCount;
                                    this.list[this.tempIndex].title=response.data.title;
                                    this.list[this.tempIndex].type=response.data.type;
                                    this.list[this.tempIndex].fakeTotalCount=response.data.fakeTotalCount;
                                }
                            })
                        }

                    }
                })
            },
            handleCurrentChange(value){
                if(this.search.page !== value){
                    this.search.page = value;
                    this.getList(this.search)
                }
            },
            getList(_params){
                let params = {
                    page: _params.page,
                    pageSize: _params.pageSize,
                }
                if (_params.title) {
                    params.title = _params.title
                }
                HttpRequest.get('/admin.php?method=fashion.getVoteList', params).then(response => {
                    if (response) {
                        this.list = _.toArray(response.data.list);
                        this.count = response.data.count;
                    }
                })
            },
            searchVote() {
                this.search.page = 1;
                this.getList(this.search)
            },
            goEdit(num,item,index) {
                if(num){
                    this.modal=JSON.parse(JSON.stringify(item));
                    this.tempIndex=index;
                }else{
                    this.modal={
                        title: '',
                        voteId: 0,
                        options: [
                            {
                                'optionId':0,
                                'optionName':"",
                                'fakeCount':0,
                                'voteCount':0,
                            },
                            {
                                'optionId':0,
                                'optionName':"",
                                'fakeCount':0,
                                'voteCount':0,
                            }],
                        isShowFake:1,
                        type:0,
                        selectCount: 1,
                    }
                }
                this.visible=true;
            },
            goBack(){
                this.visible=false;
            },
            clear() {
                this.search.title = '';
                this.search.page = 1;
                this.getList(this.search)
            },
        }
    }
</script>
<style lang="less" scoped>
    .like-tabs {
        border-bottom: 1px solid #eee;
        margin-bottom: 30px;
    }
    .like-button {
        padding-left: 10px;
        margin-bottom: 10px;
    }
    .likeTabItem{
        line-height: 60px;
        height: 50px;
        font-size: 16px;
        padding: 0 4px;
        box-sizing: border-box;

    }
    .likeTabItem :hover {
        color: #ae0fff
    }
    .active {
        border-bottom: 1px solid #337ab7;
    }
    .search-component {
        display: flex;

        label {
            margin: 5px 5px 0 0;
        }
        .button {
            margin-left: 5px;
        }
    }
    .vote-card{
        display: block;
        background: #fff;
        border:1px solid #b4bccc;
        border-radius: 5px;
        padding: 20px 30px 20px;
        .vote-tab{
            padding: 10px 0 10px;
            span{
                font-size: 18px;
                color: #000;
                margin-right: 20px;
            }
            .color{
                color: #666;
            }
            span.vote-active{
                color: blue;
            }
        }

    }
    .vote-title{
        color:#337ab7;
        font-weight: bold;
        font-size: 18px;
        .title-con{
            margin-left: 10px;
            color: #000;
        }
    }
    .vote-content{
        overflow: hidden;
        font-size: 16px;

        .vote-type{
            width:250px;
            color: #000;
        }
        .vote-options{
            overflow: hidden;
            width:600px;
            font-weight: bold;
            color: #000;
            .vote-item{
                overflow: hidden;
                padding: 10px 0 10px;
                .ticket{
                    margin-left: 20px;
                    width:70px
                }
            }
            .vote-progress{
                width:300px;
                height:10px;
                overflow: hidden;
                background: #ccc;
                .true{
                    height:10px;
                    background: #445588;
                }
                .fake{
                    height:10px;
                    background: #f58a0f;
                }
            }
        }

    }
    .font-weight{
        font-weight: bold;
    }
</style>
